import { Message } from 'element-ui'
import { isObject } from 'lodash'

const redirectToLogin = (status, router) => {
  if (window.__POWERED_BY_QIANKUN__) {
    if (Wiz.globalSettings.globalConfig.redirectLoginPath) {
      window.location.href = Wiz.globalSettings.globalConfig.redirectLoginPath
      return
    }
    localStorage.removeItem('authorization')
    router.push(`/#/login?redirect=${window.location.href.split('#')[1]}`)
  }
}

let responseResult = false
const handleSuccessRes = (response) => {
  if (response.body && response.body.code === -1) {
    Message.error(response.body.msg)
    responseResult = true
  }
}

// 拦截请求响应
export default (store, router) => {
  Wiz.ApiHooks.ResponseIntercepter = (err, res, opts) => {
    responseResult = false
    switch (opts.response.status) {
      case 200:
        handleSuccessRes(opts.response)
        break
      case 204:
        break
      case 401:
        redirectToLogin(opts.response.status, router)
        break
      case 404:
        Message.error(opts.response.error.message)
        break
      default:
        responseResult = true
        // 接口返回二进制流Error处理
        if (opts.response.body instanceof Blob) {
          opts.response.body.text().then((blobRes) => {
            try {
              const body = JSON.parse(blobRes)
              Message.error(body.error.message)
            } catch (error) {
              Message.error(`${opts.response.statusCode} ${opts.response.statusText}`)
            }
          })
          return responseResult
        }
        // 兼容后端java框架和abp框架错误返回类型
        const errorMsg = isObject(opts.response.body.error)
          ? opts.response.body.error.message
          : opts.response.body.message
        Message.error(errorMsg)
        break
    }
    return responseResult
  }
}
